<template>
    <v-touch
        @swiperight="swiperright"
        class="wrapper"
    >
        <div class="newPriceAdjustment">
            <van-nav-bar
                left-arrow
                left-text="价格变更表"
                @click-left="onClickLeft"
            >
                <template #title>
                    <span>价格变更</span>
                </template>
                <template #right>
                    <span class="iconfont iconicon-test" @click="newRawMaterials"></span>
                </template>
            </van-nav-bar>
            <section>
                <div class="boxBorder">
                    <van-cell-group>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_gy_1.png')"
                            v-model="contractInfoData.contract_no"
                            label="合同编号"
                            placeholder="请选择"
                            input-align="right"
                            is-link
                            readonly
                            class="required"
                            @click="selectContract"
                        ></van-field>
                    </van-cell-group>
                </div>
                <template v-for="(item,index) in contractInfoData.detail">
                    <div class="boxBorder" :key="index">
                        <van-cell-group>
                            <van-field
                                :left-icon="require('@/assets/images/icons/icon_gy_3.png')"
                                v-model="item.type_name"
                                label="原材料名称"
                                placeholder="请选择"
                                input-align="right"
                                is-link
                                readonly
                                class="required"
                                @click="selectMaterials(index)"
                            ></van-field>
                        </van-cell-group>
                        <van-cell-group>
                            <van-field
                                :left-icon="require('@/assets/images/icons/icon_gy_3.png')"
                                v-model="item.child_type_name"
                                label="原材料子类"
                                placeholder="系统自动生成"
                                input-align="right"
                                readonly
                            ></van-field>
                        </van-cell-group>
                        <van-cell-group>
                            <van-field
                                :left-icon="require('@/assets/images/icons/icon_gy_5.png')"
                                v-model="item.spec_name"
                                label="原材料型号"
                                placeholder="系统自动生成"
                                input-align="right"
                                readonly
                            ></van-field>
                        </van-cell-group>
                        <van-cell-group>
                            <van-field
                                :left-icon="require('@/assets/images/icons/icon_26.png')"
                                v-model="item.unit_price_before"
                                label="原合同价格"
                                placeholder="系统自动生成"
                                input-align="right"
                                readonly
                            ></van-field>
                        </van-cell-group>
                        <van-cell-group>
                            <van-field
                                :left-icon="require('@/assets/images/icons/icon_26.png')"
                                v-model="item.unit_price"
                                label="变更后价格"
                                placeholder="请输入"
                                input-align="right"
                                class="required"
                            ></van-field>
                        </van-cell-group>
                        <van-cell-group>
                            <van-field
                                :left-icon="require('@/assets/images/icons/icon_gy_2.png')"
                                v-model="item.station_name"
                                label="相关站点"
                                placeholder="系统自动生成"
                                input-align="right"
                                readonly
                            ></van-field>
                        </van-cell-group>
                        <van-cell-group>
                            <van-field
                                :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                                v-model="item.effective_date"
                                label="生效时间"
                                placeholder="请选择"
                                input-align="right"
                                is-link
                                readonly
                                class="required"
                                @click="selectTime(index,item.effective_date)"
                            ></van-field>
                        </van-cell-group>
                        <van-popup
                            v-model="selectTimeShow"
                            get-container="body"
                            position="bottom"
                            round
                        >
                            <van-datetime-picker
                                v-model="applicationTime"
                                type="datetime"
                                title="选择时间"
                                @cancel="selectTimeShow = false"
                                @confirm="onConfirm"
                            ></van-datetime-picker>
                        </van-popup>
                    </div>
                </template>
                <div class="boxBorder remarks iconfont iconbeizhu">
                    <textarea
                        rows="5"
                        v-model="contractInfoData.remarks"
                        placeholder="请填备注信息..."
                    ></textarea>
                </div>
            </section>
            <footer>
                <button @click="submit">
                    提交
                </button>
                <button @click="preservation('false')">
                    保存
                </button>
            </footer>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 新增调价
    name: 'new-price-adjustment',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/priceChange') {
            this.$store.commit('noKeepAlive', 'new-price-adjustment');
        }
        next();
    },
    data() {
        return {
            // 是否可编辑
            isEditable: false,
            // 合同信息数据
            contractInfoData: {
                // 实例id
                id: '',
                // 合同编号
                contract_no: '',
                // 合同号id
                ciid: '',
                // 备注
                remarks: '',
                // 申请类型 0内部申请 1供应商申请
                apply_type: 1,
                // 原材料调价信息
                detail: [{
                    type_name: '',
                    child_type_name: '',
                    spec_name: '',
                    unit_price_before: null,
                    unit_price: null,
                    station_name: '',
                    effective_date: this.formatDate(new Date()),
                }],
            },
            // 原材料数据
            rawMaterialData: {
                type_name: '',
                child_type_name: '',
                spec_name: '',
                unit_price_before: null,
                unit_price: null,
                station_name: '',
                effective_date: this.formatDate(new Date()),
            },
            // 选择时间层
            selectTimeShow: false,
            // 默认时间
            applicationTime: this.formatDate(new Date()),
            // 当前选择时间下标
            timeIndex: 0,
        };
    },
    computed: {},
    watch: {},
    created() { },
    activated() {
        // selectContractData选择合同返回数据
        if (this.$route.params.selectContractData) {
            // 合同号id
            this.contractInfoData.ciid = this.$route.params.selectContractData.id;
            // 合同编号
            this.contractInfoData.contract_no = this.$route.params.selectContractData.contract_no;
        }
        // rawMaterial选择原材料返回数据
        if (this.$route.params.rawMaterial) {
            const index = this.$route.params.index;
            const id = this.contractInfoData.detail[index].id;
            const newTime = this.contractInfoData.detail[index].effective_date;
            this.contractInfoData.detail[index] = this.$route.params.rawMaterial;
            this.contractInfoData.detail[index].cmid = this.$route.params.rawMaterial.cmid;
            this.contractInfoData.detail[index].civid = this.$route.params.rawMaterial.id;
            this.contractInfoData.detail[index].rootid = this.$route.params.rawMaterial.rootid;
            this.contractInfoData.detail[index].id = id;
            this.contractInfoData.detail[index].effective_date = newTime;
            // 原保供类型
            this.contractInfoData.detail[index].insurance_supply_type_before = this.$route.params.rawMaterial.insurance_supply_type;
            // 原保供量
            this.contractInfoData.detail[index].insurance_supply_before = this.$route.params.rawMaterial.insurance_supply;
            // 原含税单价（元）
            this.contractInfoData.detail[index].unit_price_before = this.$route.params.rawMaterial.unit_price;
            // 原主材税率
            this.contractInfoData.detail[index].tax_rate_before = this.$route.params.rawMaterial.tax_rate;
            // 原运输单位id
            this.contractInfoData.detail[index].transport_id_before = this.$route.params.rawMaterial.transport_id;
            // 原运输单位名称
            this.contractInfoData.detail[index].transport_name_before = this.$route.params.rawMaterial.transport_name;
            // 原运输单价（元）
            this.contractInfoData.detail[index].transport_price_before = this.$route.params.rawMaterial.transport_price;
            // 原运输税率（%）
            this.contractInfoData.detail[index].transport_rate_before = this.$route.params.rawMaterial.transport_rate;
            // 变更后价格
            this.contractInfoData.detail[index].unit_price = null;
            this.$forceUpdate();
        }
        // editData编辑数据
        if (this.$route.params.editData) {
            // 实例id
            this.contractInfoData.id = this.$route.params.editData.id;
            // 合同编号
            this.contractInfoData.contract_no = this.$route.params.editData.contract_no;
            // 合同号id
            this.contractInfoData.ciid = this.$route.params.editData.ciid;
            // 备注
            this.contractInfoData.remarks = this.$route.params.editData.remarks;

            // 编辑时获取原材料数据
            this.getRawMaterial();
        }
    },
    mounted() { },
    destroyed() { },
    methods: {
    // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/priceChange' });
            // this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/priceChange' });
            // this.$router.go(-1);
        },
        // 选择合同
        selectContract() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'selectContract',
                params: {},
            });
        },
        // 选择时间
        selectTime(timeIndex, time) {
            // 默认时间
            this.applicationTime = new Date(time);
            this.timeIndex = timeIndex;
            this.selectTimeShow = true;
        },
        // 确认选择时间
        onConfirm(date) {
            this.selectTimeShow = false;
            this.contractInfoData.detail[this.timeIndex].effective_date = this.formatDate(date);
        },
        // 格式化日期
        formatDate(date) {
            date = new Date(date);
            const Y = date.getFullYear();
            let M = date.getMonth() + 1;
            let D = date.getDate();
            let h = date.getHours();
            let m = date.getMinutes();
            let s = date.getSeconds();
            M = M < 10 ? '0' + M : M;
            D = D < 10 ? '0' + D : D;
            h = h < 10 ? '0' + h : h;
            m = m < 10 ? '0' + m : m;
            s = s < 10 ? '0' + s : s;
            return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
        },
        // 选择原材料
        selectMaterials(index) {
            if (this.contractInfoData.ciid === '') {
                this.$toast('请先选择合同');
            } else {
                this.$router.isBack = 2;
                this.$router.push({
                    name: 'selectMaterials',
                    params: {
                        index: index,
                        ciid: this.contractInfoData.ciid,
                    },
                });
            }
        },
        // 新增原材料
        newRawMaterials() {
            if (this.contractInfoData.ciid === '') {
                this.$toast('请先选择合同');
            } else {
                this.contractInfoData.detail.push(JSON.parse(JSON.stringify(this.rawMaterialData)));
            }
        },
        // 编辑时获取原材料数据
        getRawMaterial() {
            this.$axios
                .get(`/interfaceApi/Procurement/material/price/adjust/getdetailpage?mpaid=${this.contractInfoData.id}`)
                .then(res => {
                    if (res.rows.length > 0) {
                        this.contractInfoData.detail = res.rows;
                    }
                    this.$forceUpdate();
                })
                .catch(error => {
                    this.$toast({ message: error.ErrorCode.Message });
                });
        },
        // 保存
        preservation(isSubmit) {
            if (this.contractInfoData.ciid === '') {
                this.$toast('请先选择合同');
                return;
            }
            let isPreservation = true;
            this.contractInfoData.detail.forEach(item => {
                if (!item.unit_price) {
                    this.$toast('请先填写变更后价格!');
                    isPreservation = false;
                    return;
                }
            });
            if (isPreservation) {
                this.$axios
                    .post('/interfaceApi/Procurement/material/price/adjust/save', this.contractInfoData)
                    .then(res => {
                        this.contractInfoData = res;
                        if (isSubmit === 'false') {
                            this.$toast('保存成功！');
                        }
                    })
                    .catch(error => {
                        this.$toast({ message: error.ErrorCode.Message });
                    });
            }
        },
        // 提交
        async submit() {
            await this.preservation('true');
            if (this.contractInfoData.id === '') {
                this.$toast('请先保存！');
            } else {
                this.$axios
                    .get(`/interfaceApi/Procurement/material/price/adjust/submit?id=${this.contractInfoData.id}`)
                    .then(() => {
                        this.$toast('提交成功！');
                        this.$router.isBack = 1;
                        this.$router.push({
                            name: 'priceChange',
                            params: {
                                isSubmit: true,
                            },
                        });
                    })
                    .catch(error => {
                        this.$toast({ message: error.ErrorCode.Message });
                    });
            }
        },
    },
};
</script>
<style lang="stylus">
.newPriceAdjustment
    height 100%
    .van-nav-bar
        display flex
        .van-nav-bar__right
            right 0rpx
            top 0
            span
                color #fff
    section
        height calc(100% - 85rpx)
        -webkit-overflow-scrolling touch
        overflow scroll
        .boxBorder
            border-bottom 15rpx solid #F0F0F0
        .van-cell
            display flex
        .van-cell__title
            flex 1
        .van-cell__value
            flex 2
        &:not(:last-child)::after
            left 0
        .remarks
            padding 15rpx
            border-bottom 0
            position relative
            &:before
                position absolute
                top 28rpx
                left 28px
                font-size 16rpx
                color #D7D7D7
            textarea
                width 100%
                border 1px solid #D7D7D7
                border-radius 4px
                height 130rpx
                resize none
                padding 10rpx
                font-size 14rpx
                text-indent 2em
        .required
            .van-field__control
                &::placeholder
                    color red
            .van-cell__title
                span
                    position relative
                    &:after
                        content '*'
                        font-size 16rpx
                        color red
            .van-cell__right-icon
                color red
    footer
        height 40rpx
        position fixed
        width 100%
        bottom 0
        left 0
        button
            height 40rpx
            width 50%
            border none
            border-top 1px solid #D60110
            background #D60110
            color #fff
            font-size 16rpx
            &:last-child
                background #fff
                color #D60110
</style>